import { useEffect } from 'react'

/** Ustawia (lub tworzy) tag <meta> po atrybucie name albo property. */
function setMetaTag(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, key)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

/**
 * Tytuł i opis strony dla aktywnej trasy.
 *
 * Meta należą do strony, nie do dostawcy języka — inaczej przełączenie PL/EN
 * na artykule nadpisałoby tytuł artykułu tytułem całego serwisu (efekt rodzica
 * wykonuje się po efekcie dziecka). Każda trasa deklaruje swoje meta sama.
 *
 * Tagi Open Graph ustawiamy przy okazji, bo blog żyje z udostępnień —
 * link wrzucony na LinkedIn ma pokazać tytuł artykułu, nie opis firmy.
 */
export function useDocumentMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title
    setMetaTag('name', 'description', description)
    setMetaTag('property', 'og:title', title)
    setMetaTag('property', 'og:description', description)
    setMetaTag('property', 'og:url', window.location.href)
  }, [title, description])
}
